import Image from "next/image";
import { useEffect, useRef } from "react";
import { CustomLink } from "../../../Global/CustomLink";
import { AnimatePresence, motion } from "framer-motion";
import { y_variant } from "@/utils/animation/transitions";
// import useScrollLock from "@/utils/useScrollLock";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { ReactSVG } from "react-svg";
import { useAppContext } from "@/context/AppContext";
import styles from "./Modal.module.scss";

export type ModalType = {
  info: {
    src: string;
    caption: string;
    href: string;
  };
  open: boolean;
};

export const Modal = () => {
  const modalRef = useRef<HTMLDivElement>(null);
  // const { toggleLock } = useScrollLock(false);
  const { getIcon, getLabel } = useGlobalContext();
  const { instagramModal, setInstagramModal } = useAppContext();

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.focus();
    }
  }, [instagramModal]);

  return (
    <AnimatePresence>
      {instagramModal && (
        <motion.div
          variants={y_variant}
          initial={"initial"}
          animate={"animate"}
          exit={"exit"}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
          }}
          className={styles["insta-modal-wrapper"]}
        >
          <div
            ref={modalRef}
            tabIndex={0}
            role="button"
            className={styles["insta-modal"]}
            onClick={() => setInstagramModal(null)}
            onKeyDown={(e) => {
              if (e.key === "Escape") {
                setInstagramModal(null);
              }
            }}
          >
            <CustomLink
              href={instagramModal.info.href}
              target="_blank"
              rel="noreferrer noopener"
            >
              <Image
                src={instagramModal.info.src}
                alt={instagramModal.info.caption}
                height={300}
                width={300}
              />
            </CustomLink>
          </div>
          <button
            type="button"
            onClick={() => setInstagramModal(null)}
            aria-label={getLabel("modal_close")}
            className={styles["insta-close"]}
          >
            <ReactSVG src={getIcon("close")} wrapper={"svg"} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
